import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export const routerMap = [
  {
    path: '/company',
    name: 'company',
    meta: {
      icon: 'ios-cube',
      title: '企业管理'
    },
    component: Main,
    children: [
      {
        path: 'company_info',
        name: 'company_info',
        meta: {
          icon: 'ios-cube',
          title: '企业信息管理'
        },
        component: () =>
          import('@/view/company/info.vue')
      },
            {
        path: 'company_job',
        name: 'company_job',
        meta: {
          icon: 'ios-cube',
          title: '职位管理'
        },
        component: () =>
          import('@/view/company/job.vue')
      },
          {
        path: 'company_job_alarm',
        name: 'company_job_alarm',
        meta: {
          icon: 'ios-cube',
          title: '职位预警推送'
        },
        component: () =>
          import('@/view/company/job_alarm.vue')
      }
      // {
      //   path: 'job_audit',
      //   name: 'job_audit',
      //   meta: {
      //     icon: 'ios-cube',
      //     title: '临时招聘审核'
      //   },
      //   component: () =>
      //     import('@/view/company/audit.vue')
      // }
    ]
  },
  {
    path: '/person',
    name: 'person',
    meta: {
      icon: 'ios-cube',
      title: '求职者管理'
    },
    component: Main,
    children: [
      {
        path: 'person_info',
        name: 'person_info',
        meta: {
          icon: 'ios-cube',
          title: '求职者信息管理'
        },
        component: () =>
          import('@/view/person/info.vue')
      },
      {
        path: 'person_tocompany',
        name: 'person_tocompany',
        meta: {
          icon: 'ios-cube',
          title: '求职管理'
        },
        component: () =>
          import('@/view/person/tocompany.vue')
      }
      // {
      //   path: 'per_audit',
      //   name: 'per_audit',
      //   meta: {
      //     icon: 'ios-cube',
      //     title: '零工意向审核'
      //   },
      //   component: () =>
      //     import('@/view/person/audit.vue')
      // }

    ]
  },
  //  {
  //   path: '/room',
  //   name: 'room',
  //   meta: {
  //     icon: 'ios-cube',
  //     title: '宿舍管理'
  //   },
  //   component: Main,
  //   children: [
  //     {
  //       path: 'room_info',
  //       name: 'room_info',
  //       meta: {
  //         icon: 'ios-cube',
  //         title: '房间管理'
  //       },
  //       component: () =>
  //         import('@/view/roominfo/roominfo.vue')
  //     },
  //     {
  //       path: 'bed_info',
  //       name: 'bed_info',
  //       meta: {
  //         icon: 'ios-cube',
  //         title: '床位管理'
  //       },
  //       component: () =>
  //         import('@/view/roominfo/roominfo.vue')
  //     }
  //   ]
  // },
{
    path: '/news',
    name: 'news',
    meta: {
      icon: 'ios-cube',
      title: '公告管理'
    },
    component: Main,
    children: [
      {
        path: 'news_info',
        name: 'news_info',
        meta: {
          icon: 'ios-cube',
          title: '公告管理'
        },
        component: () =>
          import('@/view/news/news_info.vue')
      }
    ]
  },
  {
    path: '/report',
    name: 'report',
    meta: {
      icon: 'ios-cloud-upload',
      title: '大数据中心'
    },
    component: Main,
    children: [
      {
        path: 'report_main',
        name: 'report_main',
        meta: {
          icon: 'ios-cog',
          title: '驾驶舱'
        },
        component: () =>
          import('@/view/report/main.vue')
      },
      {
        path: 'report_zcfbqk',
        name: 'report_zcfbqk',
        meta: {
          icon: 'ios-pie',
          title: '注册发布情况调度表累计表'
        },
        component: () =>
          import('@/view/report/zcfbqk.vue')
      },
      {
        path: 'report_company',
        name: 'report_company',
        meta: {
          icon: 'ios-pie',
          title: '注册企业明细'
        },
        component: () =>
          import('@/view/report/company.vue')
      },
      {
        path: 'report_zcfbhz',
        name: 'report_zcfbhz',
        meta: {
          icon: 'ios-pie',
          title: '注册发布汇总表(区镇)'
        },
        component: () =>
          import('@/view/report/zcfbhz.vue')
      },
      {
        path: 'report_school',
        name: 'report_school',
        meta: {
          icon: 'ios-pie',
          title: '院校注册情况'
        },
        component: () =>
          import('@/view/report/school.vue')
      },
      {
        path: 'report_perreg',
        name: 'report_perreg',
        meta: {
          icon: 'ios-pie',
          title: '个人注册汇总'
        },
        component: () =>
          import('@/view/report/perreg.vue')
      },
      {
        path: 'report_perincom',
        name: 'report_perincom',
        meta: {
          icon: 'ios-pie',
          title: '投简明细'
        },
        component: () =>
          import('@/view/report/perincom.vue')
      },
      {
        path: 'report_jobs',
        name: 'report_jobs',
        meta: {
          icon: 'ios-pie',
          title: '职位明细表'
        },
        component: () =>
          import('@/view/report/jobs.vue')
      }

    ]
  },
  // {
  //   path: '/workforce',
  //   name: 'workforce',
  //   meta: {
  //     icon: 'ios-cloud-upload',
  //     title: '劳动力情况'
  //   },
  //   component: Main,
  //   children: [
  //      {
  //        path: 'workforce_info',
  //        name: 'workforce_info',
  //        meta: {
  //          icon: 'ios-cube',
  //          title: '劳动力数据管理'
  //        },
  //        component: () =>
  //          import('@/view/workforce/workforce_info.vue')
  //      },
  //     {
  //       path: 'workforce_analyse',
  //       name: 'workforce_analyse',
  //       meta: {
  //         icon: 'ios-cube',
  //         title: '劳动力分析'
  //       },
  //       component: () =>
  //         import('@/view/workforce/workforce_analyse.vue')
  //     }
  //   ]
  // },
  // {
  //     path: '/labor',
  //     name: 'labor',
  //     meta: {
  //       icon: 'ios-cloud-upload',
  //       title: '劳务派遣'
  //     },
  //     component: Main,
  //     children: [
  //       {
  //         path: 'labor_company',
  //         name: 'labor_company',
  //         meta: {
  //           icon: 'ios-cube',
  //           title: '协作单位管理'
  //         },
  //         component: () =>
  //           import('@/view/labor/labor_company.vue')
  //       },
  //       {
  //               path: 'labor_contract',
  //               name: 'labor_contract',
  //               meta: {
  //                 icon: 'ios-cube',
  //                 title: '合同管理'
  //               },
  //               component: () =>
  //                 import('@/view/labor/labor_contract.vue')
  //             },
  //       {
  //         path: 'labor_business',
  //         name: 'labor_business',
  //         meta: {
  //           icon: 'ios-cube',
  //           title: '派遣业务管理'
  //         },
  //         component: () =>
  //           import('@/view/labor/labor_business.vue')
  //       }
  //     ]
  //   },
  // {
  //     path: '/law',
  //     name: 'law',
  //     meta: {
  //       icon: 'ios-cloud-upload',
  //       title: '法律服务'
  //     },
  //     component: Main,
  //     children: [
  //       {
  //         path: 'law_info',
  //         name: 'law_info',
  //         meta: {
  //           icon: 'ios-cube',
  //           title: '法律服务'
  //         },
  //         component: () =>
  //           import('@/view/law/law_info.vue')
  //       }
  //     ]
  //   },
  // {
  //     path: '/cost',
  //     name: 'cost',
  //     meta: {
  //       icon: 'ios-cloud-upload',
  //       title: '费用管理'
  //     },
  //     component: Main,
  //     children: [
  //       {
  //         path: 'cost_info',
  //         name: 'cost_info',
  //         meta: {
  //           icon: 'ios-cube',
  //           title: '费用管理'
  //         },
  //         component: () =>
  //           import('@/view/cost/cost_info.vue')
  //       }
  //     ]
  //   },
  // {
  //     path: '/testimonials',
  //     name: 'testimonials',
  //     meta: {
  //       icon: 'ios-cloud-upload',
  //       title: '推荐管理'
  //     },
  //     component: Main,
  //     children: [
  //       {
  //         path: 'testimonials_info',
  //         name: 'testimonials_info',
  //         meta: {
  //           icon: 'ios-cube',
  //           title: '推荐管理'
  //         },
  //         component: () =>
  //           import('@/view/testimonials/testimonials_info.vue')
  //       }
  //     ]
  //   },
  // {
  //     path: '/evaluations',
  //     name: 'evaluations',
  //     meta: {
  //       icon: 'ios-cloud-upload',
  //       title: '评价管理'
  //     },
  //     component: Main,
  //     children: [
  //       {
  //         path: 'evaluations_info',
  //         name: 'evaluations_info',
  //         meta: {
  //           icon: 'ios-cube',
  //           title: '评价管理'
  //         },
  //         component: () =>
  //           import('@/view/evaluations/evaluations_info.vue')
  //       }
  //     ]
  //   },
//  企业部分
  {
    path: '/account',
    name: 'account',
    meta: {
      icon: 'ios-cloud-upload',
      title: '信息管理'
    },
    component: Main,
    children: [
      {
        path: 'account_company_info',
        name: 'account_company_info',
        meta: {
          icon: 'ios-cog',
          title: '基础信息管理'
        },
        component: () =>
          import('@/view/account/company_info.vue')
      }
    ]
  },
  {
    path: '/apply',
    name: 'apply',
    meta: {
      icon: 'ios-cloud-upload',
      title: '面试'
    },
    component: Main,
    children: [
      {
        path: 'apply_jobfair',
        name: 'apply_jobfair',
        meta: {
          icon: 'ios-cog',
          title: '远程面试'
        },
        component: () =>
          import('@/view/apply/jobfair.vue')
      },
      {
        path: 'apply_online',
        name: 'apply_online',
        meta: {
          icon: 'ios-cog',
          title: '在线面试',
          hideInMenu: true
        },
        component: () =>
          import('@/view/apply/online.vue')
      }] },
  {
    path: '/jobs',
    name: 'jobs',
    meta: {
      icon: 'ios-cloud-upload',
      title: '职位管理'
    },
    component: Main,
    children: [
      {
        path: 'apply_job',
        name: 'apply_job',
        meta: {
          icon: 'ios-cog',
          title: '职位管理'
        },
        component: () =>
          import('@/view/apply/job.vue')
      },
      // {
      //   path: 'temporary_job',
      //   name: 'temporary_job',
      //   meta: {
      //     icon: 'ios-cog',
      //     title: '临时招聘管理'
      //   },
      //   component: () =>
      //           import('@/view/apply/temporary_job.vue')
      // },
      // {
      //   path: 'broker_job',
      //   name: 'broker_job',
      //   meta: {
      //     icon: 'ios-cog',
      //     title: '委托招聘管理'
      //   },
      //   component: () =>
      //           import('@/view/apply/broker_job.vue')
      // }]},

      {
        path: '/interview',
        name: 'interview',
        meta: {
          icon: 'ios-cloud-upload',
          title: '应聘管理'
        },
        component: Main,
        children: [
          {
            path: 'apply_application',
            name: 'apply_application',
            meta: {
              icon: 'ios-cog',
              title: '应聘管理'
            },
            component: () =>
              import('@/view/apply/application.vue')
          },
          {
            path: 'apply_person',
            name: 'apply_person',
            meta: {
              icon: 'ios-cog',
              title: '人才管理'
            },
            component: () =>
              import('@/view/apply/person.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/usermanage',
    name: 'usermanage',
    meta: {
      icon: 'md-contacts',
      title: '用户管理'
    },
    component: Main,
    children: [{
      path: 'user',
      name: 'user',
      meta: {
        icon: 'ios-people',
        title: '用户列表'
      },
      component: () =>
        import('@/view/user-manage/user.vue')
    },

      {
        path: 'menus',
        name: 'menus',
        meta: {
          icon: 'ios-menu',
          title: '菜单组件'
        },
        component: () =>
          import('@/view/user-manage/routescomponents.vue')
      },
      {
        path: 'role',
        name: 'role',
        meta: {
          icon: 'ios-person',
          title: '角色管理'
        },
        component: () =>
          import('@/view/user-manage/role.vue')
      }
    ]
  },
  {
    path: '/basedata',
    name: 'basedata',
    meta: {
      icon: 'ios-settings',
      title: '基础数据'
    },
    component: Main,
    children: [
      {
        path: 'industry_manage',
        name: 'industry_manage',
        meta: {
          icon: 'ios-list-box',
          title: '行业分类管理'
        },
        component: () =>
          import('@/view/industry/industry_manage.vue')
      }
    ]
  },
  {
    path: '/train',
    name: 'train',
    meta: {
      icon: 'ios-school',
      title: '培训鉴定'
    },
    component: Main,
    children: [
      {
        path: 'train_manage',
        name: 'train_manage',
        meta: {
          icon: 'ios-book',
          title: '培训鉴定管理'
        },
        component: () =>
          import('@/view/train/train_manage.vue')
      }
    ]
  },
  {
    path: '/school',
    name: 'school',
    meta: {
      icon: 'ios-people',
      title: '校企合作'
    },
    component: Main,
    children: [
      {
        path: 'school_manage',
        name: 'school_manage',
        meta: {
          icon: 'ios-briefcase',
          title: '校企合作管理'
        },
        component: () =>
          import('@/view/school/school_manage.vue')
      }
    ]
  }
  // {
  //   path: '/activity',
  //   name: 'activity',
  //   meta: {
  //     icon: 'ios-book-outline',
  //     title: '活动'
  //   },
  //   component: Main,
  //   children: [{
  //     path: 'voteshow',
  //     name: 'voteshow',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '投票'
  //     },
  //     component: () =>
  //       import('@/view/activity/voteshow_1.vue')
  //   }
  //   ]
  // },
  // {
  //   path: '/hr_bussiness',
  //   name: 'hr_bussiness',
  //   meta: {
  //     icon: 'ios-book-outline',
  //     title: '人力资源'
  //   },
  //   component: Main,
  //   children: [{
  //     path: 'hr_bussiness_info',
  //     name: 'hr_bussiness_info',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '求职跟踪服务'
  //     },
  //     component: () =>
  //       import('@/view/hr/hr_business_info.vue')
  //   }, {
  //     path: 'hr_bussiness_config',
  //     name: 'hr_bussiness_config',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '业务设置'
  //     },
  //     component: () =>
  //       import('@/view/hr/hr_bussiness_config.vue')
  //   }
  //
  //   ]
  // },
  // {
  //   path: '/assist',
  //   name: 'assist',
  //   meta: {
  //     icon: 'ios-book-outline',
  //     title: '援助人员管理'
  //   },
  //   component: Main,
  //   children: [{
  //     path: 'assist_person',
  //     name: 'assist_person',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '援助人员信息管理'
  //     },
  //     component: () =>
  //       import('@/view/assist/assist_person.vue')
  //   },
  //     {
  //       path: 'assist_out',
  //       name: 'assist_out',
  //       meta: {
  //         icon: 'ios-book-outline',
  //         title: '援助情况反馈'
  //       },
  //       component: () =>
  //         import('@/view/report/assist_out.vue')
  //     },
  //   {
  //     path: 'assist_parameter',
  //     name: 'assist_parameter',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '参数管理'
  //     },
  //     component: () =>
  //       import('@/view/sys/assist_parameter.vue')
  //   }]},
  //     {
  //       path: '/assist_s',
  //       name: 'assist_s',
  //       meta: {
  //         icon: 'ios-book-outline',
  //         title: '援助服务'
  //       },
  //       component: Main,
  //       children: [{
  //         path: 'assist_server',
  //         name: 'assist_server',
  //         meta: {
  //           icon: 'ios-book-outline',
  //           title: '援助服务'
  //         },
  //         component: () =>
  //           import('@/view/assist/assist_server.vue')
  //       }, {
  //         path: 'assist_kpi',
  //         name: 'assist_kpi',
  //         meta: {
  //           icon: 'ios-book-outline',
  //           title: '援助服务再分配'
  //         },
  //         component: () =>
  //           import('@/view/assist/assist_kpi.vue')
  //       }
  //   ]
  // },
  // {
  //   path: '/ljtc',
  //   name: 'ljtc',
  //   meta: {
  //     icon: 'ios-book-outline',
  //     title: '乐就小程序'
  //   },
  //   component: Main,
  //   children: [{
  //     path: 'school_jobfair',
  //     name: 'school_jobfair',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '高校网络招聘会'
  //     },
  //     component: () =>
  //       import('@/view/jobfair/jobfair_online.vue')
  //   },
  //     {
  //       path: 'personnelapplyconfig',
  //       name: 'personnelapplyconfig',
  //       meta: {
  //         icon: 'ios-book-outline',
  //         title: '预约设置'
  //       },
  //       component: () =>
  //         import('@/view/personnel/applyconfig.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/personnel',
  //   name: 'personnel',
  //   meta: {
  //     icon: 'ios-book-outline',
  //     title: '人才编码'
  //   },
  //   component: Main,
  //   children: [{
  //     path: 'personnelapply',
  //     name: 'personnelapply',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '预约记录'
  //     },
  //     component: () =>
  //       import('@/view/personnel/applylist.vue')
  //   },
  //     {
  //       path: 'personnelapplyconfig',
  //       name: 'personnelapplyconfig',
  //       meta: {
  //         icon: 'ios-book-outline',
  //         title: '预约设置'
  //       },
  //       component: () =>
  //         import('@/view/personnel/applyconfig.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/allopatry',
  //   name: 'allopatry',
  //   meta: {
  //     icon: 'ios-book-outline',
  //     title: '医疗保障'
  //   },
  //   component: Main,
  //   children: [{
  //     path: 'allopatryinfo',
  //     name: 'allopatryinfo',
  //     meta: {
  //       icon: 'ios-book-outline',
  //       title: '居外就医申请'
  //     },
  //     component: () =>
  //       import('@/view/allopatry/info.vue')
  //   }
  //   ]
  // }
]

export const routes = [{
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            icon: 'md-home',
            hideInMenu: true
        },
        component: () =>
            import('@/view/login/login.vue')
    },
  {
    path: '/gzh',
    name: 'gzh',
    meta: {
      title: '办事大厅',
      icon: 'md-home',
      hideInMenu: true
    },
    component: () =>
      import('@/view/gzh.vue')
  },

  {
    path: '/login_n',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      icon: 'md-home',
      hideInMenu: true
    },
    component: () =>
      import('@/view/login/login.vue')
  },

  {
    path: '/resume',
    name: 'resume',
    meta: {
      title: '个人简历',
      icon: 'md-home',
      hideInMenu: true
    },
    component: () =>
      import('@/view/person/resume.vue')
  },

    {
        path: '/',
        name: '_home',
        redirect: '/home',
        component: Main,
        meta: {
            hideInMenu: true,
            notCache: true
        },
        children: [{
            path: '/home',
            name: 'home',
            meta: {
                hideInMenu: true,
                title: '首页',
                notCache: true,
                icon: 'md-home'
            },
            component: () =>
                import('@/view/single-page/home')
        }]
    },

    {
        path: '/403',
        name: 'error_403',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import('@/view/error-page/403.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import('@/view/error-page/500.vue')
    },
    {
        path: '*',
        meta: {
            icon: 'md-home',
            hideInMenu: true
        },
        component: () =>
            import('@/view/error-page/404.vue')
    }
]
